export default "__VITE_PUBLIC_ASSET__5cef4cdc__"